import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useDistributorStore = defineStore("distributor", () => {
  const httpStore = useHttpStore();

  const getDistributors = (emailAddress) => {
    var params = {
      emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributors", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getSuperDistiLinkedList = (emailAddress) => {
    var params = {
        emailAddress: emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetSuperDistiLinkedList", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const superDistiAddLink = (emailAddress, affinityId, accountName, country) => {
    var params = {
        linkItemData: {
            emailAddress,
            affinityId,
            accountName,
            country
        }
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/SuperDistiAddLink", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const superDistiRemoveLink = (userAffinityLinkId) => {
    var params = {
        userAffinityLinkId
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/SuperDistiRemoveLink", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getDistributors,
    getSuperDistiLinkedList,
    superDistiAddLink,
    superDistiRemoveLink
  };
});